import { Box, Typography, styled } from "@mui/material";
import { colors } from "../../../../theme/colors";

export const FooterWrapper = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "24px",
  marginTop: "32px",
});

export const FooterPlaceholder = styled(Typography)({
  fontSize: "12px",
  fontWeight: 400,
  color: colors.text.secondary,
  fontFamily: "Nunito",
  textAlign: "center",
  width: "100%",
});

export const FooterContainer = styled(Box)({
  display: "flex",
  gap: "24px",
  justifyContent: "space-between",
  alignItems: "center",
});

export const FooterDisclaimer = styled(Typography)({
  fontSize: "12px",
  color: colors.text.primary,
  fontFamily: "Nunito",
  lineHeight: "18px",
});

export const FooterContent = styled(Box)({
  display: "flex",
  justifyContent: "flex-end",
  flexDirection: "row",
  alignItems: "center",
});

export const TotalFee = styled(Typography)({
  fontSize: "18px",
  fontWeight: 700,
  color: colors.text.primary,
  marginRight: "24px",
  fontFamily: "Sora",
  whiteSpace: "nowrap",
});

export const FooterButtons = styled(Box)({
  display: "flex",
  gap: "24px",
  "& button": {
    minWidth: "160px",
  },
});
